// extracted by mini-css-extract-plugin
export default {"imgContainer":"webbook-guide-view_imgContainer__4QAoL"};